import { Navigate, useLocation, useParams } from 'react-router-dom';

/** Preserve query string and hash on redirect (301-equivalent client replace). */
function redirectTo(path) {
  const location = useLocation();
  return `${path}${location.search}${location.hash}`;
}

export function RedirectToForts() {
  return <Navigate to={redirectTo('/forts')} replace />;
}

export function RedirectFortDetailToCanonical() {
  const { id } = useParams();
  const location = useLocation();
  const key = encodeURIComponent(String(id ?? ''));
  return <Navigate to={`/fort/${key}${location.search}${location.hash}`} replace />;
}

export function RedirectOrganizationDetailToCanonical() {
  const { id } = useParams();
  const location = useLocation();
  const key = encodeURIComponent(String(id ?? ''));
  return <Navigate to={`/organizations/org/${key}${location.search}${location.hash}`} replace />;
}

/** Canonical in-app paths for entities with duplicate URL history. */
export function fortPath(fortOrKey) {
  if (fortOrKey == null || fortOrKey === '') return '/forts';
  if (typeof fortOrKey === 'object') {
    const key = fortOrKey.slug ?? fortOrKey.id;
    return key != null ? `/fort/${encodeURIComponent(String(key))}` : '/forts';
  }
  return `/fort/${encodeURIComponent(String(fortOrKey))}`;
}

export function organizationPath(org) {
  if (!org) return '/organizations';
  const key = org.slug ?? org.id;
  return key != null ? `/organizations/org/${encodeURIComponent(String(key))}` : '/organizations';
}

export const CANONICAL_ROUTES = {
  fortsList: '/forts',
  fortDetail: '/fort/:slugOrId',
  organizationDetail: '/organizations/org/:slugOrId',
};
